module.exports = __webpack_public_path__ + "img/campaign-step-2.6b9e5538.jpg";